import {
  odjComm,
  odjPleniaire,
  odjPresidence,
  odjEven,
  trelloEvent,
  gdrive,
  organigram,
} from "./links";
import { defaultJiData } from "./default";
import { UnityData } from "../../LinkDataInterface";

export const polylan: UnityData = {
  ...defaultJiData,
  groups: [
    [], //folder utiles
    [odjPleniaire, odjEven, odjComm, odjPresidence],
    [gdrive, organigram], //general
    [], //prévention
    [trelloEvent], //log
  ],
};
